






































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { EEntities } from '@/types'
import {
  IGenericJSONMessage,
  IProjectsOutputIntegrationsHarvestIntegrationInfo,
} from '@/api/types/response.types'

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default Vue.extend({
  name: 'HarvestIntegrationAccordion',

  props: {
    type: {
      type: String as () => EEntities,
      required: true,
    },
    entityId: {
      type: Number,
      required: true,
    },
    harvestIntegration: {
      type: Object as () => IProjectsOutputIntegrationsHarvestIntegrationInfo,
      required: true,
    },
  },

  data() {
    return {
      isSubmitting: false,
      formData: {
        harvestEnabled: false,
      },
    }
  },

  computed: {
    itemName(): string {
      return TextAssistant.itemSingularName(this.type).toLowerCase()
    },

    buttonColor(): string {
      return ColorAssistant.getEntityColor(this.type)
    },
  },

  watch: {
    harvestIntegration: {
      immediate: true,
      handler(newVal) {
        this.formData.harvestEnabled = newVal.enabled
      },
    },
  },

  methods: {
    async save(enabled: boolean): Promise<IGenericJSONMessage> {
      if (this.type === EEntities.MAILBOXES) {
        return await MailboxesAPI.post_SetHarvestEnabled(this.entityId, enabled)
      } else {
        return await InternalProjectsAPI.post_SetHarvestEnabled(
          this.entityId,
          enabled,
        )
      }
    },

    async submitHandler() {
      // @ts-ignore
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.isSubmitting = true
          try {
            const response = await this.save(this.formData.harvestEnabled)
            this.$messaging.showSuccess(response.message)
          } catch (err) {
            this.$error.emit(err, true)
          } finally {
            this.isSubmitting = false
          }
        }
      })
    },
  },
})
